import React, { useEffect, useRef, useState } from 'react'
import './momentum-landing.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCubes } from '@fortawesome/free-solid-svg-icons';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import LevelsList from './momentum-list.component';
import LevelsForm from './momentum-form.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import { useSelector } from 'react-redux';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import { properCase } from '@/utils/properCase';
import { getCollectionFromDb } from '@/utils/getDataFromDb';
import MomentumList from './momentum-list.component';
import MomentumForm from './momentum-form.component';
import MomentumUploadPage from './momentum-upload-page.component';

const MomentumLandingPage = ({
  gameData,
  gameStats,
  gameElements,
}) => {

  const membership = useSelector(state => state.userData.membership);
  const screenSize = useSelector(state => state.contentData.screenSize);
  const [showUpgradeModal, setShowUpgradeModal] = useState(null);
  const [momentumCardsFromDb, setMomentumCardsFromDb] = useState(null);
  const [momentumCardsRetrieved, setMomentumCardsRetrieved] = useState(false);
  const momentumCardsRef = useRef();
  let momentumCardsListener;
  const navigate = useNavigate();

  useEffect(() => {
    checkMembership();
  }, [])

  useEffect(() => {
    if (!gameData || momentumCardsRetrieved) return;
    getGameElementsToManage();
    setMomentumCardsRetrieved(true);
  }, [gameData])

  function checkMembership() {
    const element = 'momentum'
    const res = testMemberRestrictions({ 'gameData': gameData, 'membership': membership, 'element': element })
    // console.log(res);

    if (res.disabled) {
      let message = ''
      const planRest = membershipRestrictions[membership.membership];
      if (res.disabledReason.includes(element)) {
        message = `While using the ${planRest.title}, you are not able to access ${properCase(element)}.`;
      }
      setShowUpgradeModal(message)
    }
  }

  function getGameElementsToManage() {
    getCollectionFromDb({
      "collection": `games/${gameData.gameId}/gameElements`,
      "query1": {
        "key": "type",
        "condition": "==",
        "value": "momentum"
      },
      "callback": callback,
      "handleListener": handleListener
    })
    function callback(data) {
      momentumCardsRef.current = {
        ...momentumCardsRef.current,
        ...{ [data.id]: data }
      }
      setMomentumCardsFromDb(momentumCardsRef.current);
    }
    function handleListener(data) {
      momentumCardsListener = data;
    }
  }

  return (
    <div className={`momentum-landing ${screenSize}`}>
      <div className='g-card momentum-card'>
        <BackButton cancel={() => navigate(-1)} />
        <div className="g-space-1"></div>
        <div className='card-title'>
          <ImageContainer src='/images/icons/momentum2.png' alt='momentum card icon' className='head-icon' />
          Create and Edit Momentum Cards
        </div>
        <hr />
        <div className='momentum-landing-content'>
          <Routes>
            <Route path='' element={
              <MomentumList
                gameElements={gameElements}
                momentumCardsFromDb={momentumCardsFromDb}
                gameData={gameData} />
            }></Route>
            <Route path='create' element={
              <MomentumForm
                gameElements={gameElements}
                gameStats={gameStats}
                momentumCardsFromDb={momentumCardsFromDb}
                gameData={gameData} />
            }></Route>
            <Route path='edit/:momentumCardPath' element={
              <MomentumForm
                gameElements={gameElements}
                momentumCardsFromDb={momentumCardsFromDb}
                gameStats={gameStats}
                gameData={gameData} />
            }></Route>
            <Route path="*" element={<Navigate replace to="/404" />} />
          </Routes>
        </div>
      </div>
      <UpgradeRequiredModal
        show={showUpgradeModal}
        cancel={() => setShowUpgradeModal(null)}
        message={showUpgradeModal}
      />
    </div>
  )
}

export default MomentumLandingPage